// extracted by mini-css-extract-plugin
export default {"tag":"user-usage-status-tag_tag__6zR9F"};